"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pencil = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Pencil = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { d: "M12.1,7.5 L16.5,11.9 L8.7,19.7 C8.5,19.9 8.3,20 8,20 L5,20 C4.4,20 4,19.6 4,19 L4,16 C4,15.7 4.1,15.5 4.3,15.3 L12.1,7.5 Z M19.7,7.3 C20.1,7.7 20.1,8.3 19.7,8.7 L17.9,10.5 L13.5,6.1 L15.3,4.3 C15.7,3.9 16.3,3.9 16.7,4.3 L19.7,7.3 Z", id: "PENCIL-SVG-ICON-PATH1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "PENCIL-SVG-ICON-MASK2", fill: "white" },
                React.createElement("use", { xlinkHref: "#PENCIL-SVG-ICON-PATH1" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#PENCIL-SVG-ICON-MASK2)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Pencil = Pencil;
//# sourceMappingURL=Pencil.js.map